import { Text } from '@chakra-ui/react'
import { useAlert } from '@common/hooks'
import { LOCAL_EMAIL_RESET_PASSWORD } from '@constants/local-storage'
import RouterUrl from '@constants/router.constant'
import { medusaClient } from '@lib/config'
import { handleAuthError } from '@lib/util/handle-error'
import Button from '@modules/common/components/button'
import Input from '@modules/common/components/input'
import { useRouter } from 'next/router'
import React, { Fragment, useState } from 'react'
import { useForm } from 'react-hook-form'
import AuthForm from '../auth-form'

const RequestResetPassword = () => {
  const [authError, setAuthError] = useState<string | undefined>(undefined)
  const [loading, setLoading] = useState(false)
  const router = useRouter()

  const { successToast } = useAlert()

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors }
  } = useForm<{ email: string }>()

  const onSubmit = handleSubmit(async ({ email }) => {
    setAuthError('')
    setLoading(true)
    medusaClient.customers
      .generatePasswordToken({ email })
      .then(() => {
        setLoading(false)
        localStorage.setItem(LOCAL_EMAIL_RESET_PASSWORD, email)
        reset({ email: '' })
        successToast({
          title: 'Sent mail success',
          description: 'Please check your email to process reset password'
        })
      })
      .catch((e) => {
        if (e?.response?.status == 404) {
          setAuthError('Email not found or not exist')
          setLoading(false)
          return
        }
        handleAuthError(e, (mess) => {
          setAuthError(mess)
        })
        setLoading(false)
      })
  })

  return (
    <AuthForm onSubmit={onSubmit}>
      <Input
        label="Email"
        {...register('email', { required: 'Email is required' })}
        autoComplete="email"
        disabled={loading}
        errors={errors}
      />
      {authError && (
        <div>
          <span className="w-full text-base text-rose-500 text-small-regular">
            {authError}
          </span>
        </div>
      )}
      <Button isLoading={loading} disabled={loading}>
        Send
      </Button>
      <Text fontSize={'18px'} textAlign={'center'}>
        <button
          onClick={() => {
            router.replace(RouterUrl.AUTH.LOGIN)
          }}
          className="underline"
          type="button"
        >
          Back to login{' '}
        </button>
      </Text>
    </AuthForm>
  )
}

export default RequestResetPassword
